<template>
  <div>
    <v-row justify="end" align="center">
      <v-col cols="2">
        <div v-if="item.product.featuredImage">
          <v-img
            :max-height="imageSize"
            :max-width="imageSize"
            :min-height="imageSize"
            :min-width="imageSize"
            :key="item.featuredImage"
            :src="attnThumbHref(item.product.featuredImage, 128)"
          ></v-img>
        </div>
        <div v-else>
          <v-img
            :max-height="imageSize"
            :max-width="imageSize"
            :min-height="imageSize"
            :min-width="imageSize"
            contain
            src="@/assets/indexLogo@180h.png"
          />
        </div>
      </v-col>
      <v-col cols="2">
        <h4 class="d-inline-flex">
          {{ get(item.product, 'name', '-') }}
        </h4>
      </v-col>
      <v-col cols="2">
        <h4 class="d-inline-flex">
          {{ getCategoryNameById(item.product.category) }}
        </h4>
      </v-col>
      <v-col cols="2">
        <div class="d-flex">
          <h4>HK$</h4>
          <h4 :class="item.product.discountedPrice ? 'stripeClass' : ''">
            {{ get(item.product, 'listedPrice', '-') }}
          </h4>
          <h4 class="ml-2">{{ get(item.product, 'discountedPrice', '-') }}</h4>
        </div>
      </v-col>
      <v-col cols="2">
        <div class="d-flex align-center justify-center">
          <v-chip v-if="!isEditable" style="width: 100%" outlined class="d-flex justify-center">
            x{{ get(item, 'qty', '-') }}
          </v-chip>

          <v-text-field
            v-else
            class="shrink px-0 custom-number-input mt-auto"
            hide-details
            dense
            outlined
            rounded
            type="number"
            :min="1"
            v-model.number="item.qty"
            append-icon="mdi-plus"
            prepend-inner-icon="mdi-minus"
            @click:append="increment(item)"
            @click:prepend-inner="decrement(item)"
          >
          </v-text-field>
        </div>
      </v-col>
      <v-col cols="2">
        <div class="d-flex">
          <h4>HK$</h4>
          <h4 class="ml-3">{{ computedSubTotal(item) }}</h4>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { attnThumbHref } from '@/services/filters';
import { get } from 'lodash';
import { listProductCategories } from '@/api/productCategory';
import api from '@/api';
import ImgWithPlaceholder from '@/components/imgWithPlaceholder';

export default {
  name: 'ProductItemRow',
  components: { ImgWithPlaceholder },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    productCategories: { type: Array, default: () => [] },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageSize: 100,
    };
  },
  methods: {
    get,
    attnThumbHref,
    getCategoryNameById(categoryId) {
      return (
        this.productCategories.find(el => {
          return el._id === categoryId;
        })?.title || '-'
      );
    },
    computedSubTotal(item) {
      const amount = item.product.discountedPrice
        ? item.product.discountedPrice
        : item.product.listedPrice;
      return Number((amount * item.qty).toFixed(2));
    },
    increment(product) {
      product.qty += 1;
    },
    decrement(product) {
      if (product.qty > 1) {
        product.qty -= 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stripeClass {
  text-decoration: line-through;
  text-decoration-thickness: 2px;
}
::v-deep .custom-number-input {
  .v-input__slot {
    padding: 0 2px !important;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
}
</style>
